import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddPartnerModal from './AddPartnerModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-parnter-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddPartnerModal)
    }).$mount('#gnzs-1c-amo__add-parnter-modal-container');
}

